module.exports = __webpack_public_path__ + "static/media/checkout.79a2da5b.png";